export enum LostAndFoundState {

  "FELVEVE" = "F",
  "VISSZAADVA" = "R",
  "POSTAZVA" = "P",
  "SELEJTEZVE"="D"

  
}
